<template>
  <div class="TJDetailMenu">
    <div
      :class="[
        {
          'topBorder': item.topBorder == true,
          'rightBorder': item.rightBorder == false,
          'bottomBorder': item.bottomBorder == false,
          'absorbance': item.type != null
        },
        'box',
      ]"
      v-for="(item, index) of dataList"
      :key="index"
      :style="'width:' + item.width"
    >
      <p >{{ item.name }}:</p>
      <p>{{ item.value == null ? '-' : item.value }}</p>
    </div>
  </div>
</template> 
<script>
  export default {
    props: ['dataList'],
  }
</script>
<style lang="scss" scoped>
.TJDetailMenu {
  min-height: px(90);
  background-color: #fff;
  border-radius: 5px;
  padding: 0 px(8);
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  .box {
    width: 33%;
    border-right: 1px solid $border-color;
    box-sizing: border-box;
    padding: px(10) 0 0 px(10);
    height: px(80);
    border-bottom: 1px solid $border-color;
    p:nth-child(1) {
      color: #999999;
      font-size: $table-td-size;
      margin-bottom: px(6);
    }
    p:nth-child(2) {
      margin-top: $gap;
      font-size: $table-td-size;
      color: #333333;
    }
  }

  .box:nth-last-child(1) {
    border-right: none;
  }
  .topBorder {
    border-top: 1px solid $border-color;
  }
  .bottomBorder {
    border-bottom: none !important;
  }
  .rightBorder {
    border-right: none;
  }
  .absorbance {
    height: px(100);
  }
}


</style>